// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"581":"grab","594":"about"}[chunkId] + "." + {"581":"6191fa43","594":"62c31966"}[chunkId] + ".js";
};